document.addEventListener('scroll', () => {
    const header = document.getElementById('header');

    if (window.scrollY > 200) {
        header.classList.add('shrinked');
    } else {
        header.classList.remove('shrinked');
    }
});
